function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1a1 1 0 011-1h18a1 1 0 010 2H1a1 1 0 01-1-1zm19 15H1a1 1 0 000 2h18a1 1 0 000-2zm0-8H1a1 1 0 000 2h18a1 1 0 000-2z",
  fill: "#0080ff",
  "data-name": "Vrstva 1"
}));

function SvgMobileMenuOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxOCI+PGRlZnM+PHN0eWxlPi5jbHMtMSB7ZmlsbDogIzAwODBmZjt9DQo8L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iVnJzdHZhXzEiIGRhdGEtbmFtZT0iVnJzdHZhIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAsMUExLDEsMCwwLDEsMSwwSDE5YTEsMSwwLDAsMSwwLDJIMUExLDEsMCwwLDEsMCwxWk0xOSwxNkgxYTEsMSwwLDAsMCwwLDJIMTlhMSwxLDAsMCwwLDAtMlptMC04SDFhMSwxLDAsMCwwLDAsMkgxOWExLDEsMCwwLDAsMC0yWiIvPjwvZz48L2c+PC9zdmc+";
export { SvgMobileMenuOn as ReactComponent };